"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, useContext, useState } from "react";
import { useStore } from "zustand";
import { createProfileItemsSelectionStore } from "./profile-items-selection-store";
const ProfileStoreContext = createContext(createProfileItemsSelectionStore());
export function ProfileItemsSelectionProvider(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  const [store] = useState(createProfileItemsSelectionStore);
  let t1;
  if ($[0] !== children || $[1] !== store) {
    t1 = <ProfileStoreContext.Provider value={store}>{children}</ProfileStoreContext.Provider>;
    $[0] = children;
    $[1] = store;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
export const useProfileItemsSelectionStore = selector => {
  const store = useContext(ProfileStoreContext);
  return useStore(store, selector);
};